export default __webpack_public_path__ + "static/media/facebook.90fddd94.svg";